import { Suspense } from 'react';

export default function SimpleApp() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="p-4 text-center">
        <h1 className="font-display text-heading-lg">Simple App Shell</h1>
        <p className="text-muted-foreground">Minimal environment active.</p>
      </div>
    </Suspense>
  );
}

